import React, { useState, useEffect } from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';
import { useClient } from '../../context/ClientContext';

export default function ConversionLag() {
  const { brand, fetcher } = useClient();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetcher.fetchConversionLag()
      .then(setData)
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 animate-pulse">
        <div className="h-4 bg-gray-200 rounded w-1/3 mb-4"></div>
        <div className="h-48 bg-gray-200 rounded"></div>
      </div>
    );
  }

  if (!data?.buckets?.length) return null;

  const primaryColor = brand.colors?.primary || '#2563eb';
  const totalConversions = data.buckets.reduce((sum, b) => sum + b.conversions, 0);

  return (
    <div className="bg-white rounded-xl shadow-sm hover:shadow-md transition-all duration-200 border border-gray-100 p-6">
      <div>
        <h3 className="text-sm font-semibold text-gray-700 uppercase tracking-wide"
            style={{ fontFamily: brand.typography?.headerFont }}>
          Conversion Lag
        </h3>
        <p className="text-xs text-gray-400 mt-1 mb-4">How long after clicking do people convert? (last 30 days)</p>
      </div>

      <ResponsiveContainer width="100%" height={220}>
        <BarChart data={data.buckets} margin={{ top: 5, right: 10, left: -10, bottom: 5 }}>
          <XAxis
            dataKey="label"
            tick={{ fontSize: 11, fill: '#666' }}
            tickLine={false}
            axisLine={{ stroke: '#e5e7eb' }}
          />
          <YAxis
            allowDecimals={false}
            tick={{ fontSize: 11, fill: '#666' }}
            tickLine={false}
            axisLine={false}
          />
          <Tooltip
            formatter={(value) => [`${value} conversions (${totalConversions > 0 ? ((value / totalConversions) * 100).toFixed(0) : 0}%)`, '']}
            labelStyle={{ fontWeight: 600 }}
            contentStyle={{ borderRadius: 8, border: '1px solid #e5e7eb' }}
          />
          <Bar
            dataKey="conversions"
            fill={primaryColor}
            radius={[4, 4, 0, 0]}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
